// 三个储值页统一映入函数，如果修改V1-storager记得同步
import {
  getLocaLclStor,
  getLocationNameByVal,
  getCurLocation
} from '@store/officialStore/storager';
import globalConfig from '@utiles/officialStore/globalConfig';
import { clickButton as clickButtonV0 } from '@plugins/biPoint/_configSdkstore';
import {
  clickButton as clickButtonV1,
  locationType
} from '@plugins/biPoint/_configWebstoreV1';
import { clickButton as clickButtonV2 } from '@plugins/biPoint/_configWebstoreV2';
import { clickButton as clickButtonV3 } from '@plugins/biPoint/_configWebstoreV3';
import { clickButton as clickButtonV35 } from '@plugins/biPoint/_configWebstoreV35';
import { pushTrackEvent } from '@utiles/officialTopupNew/trackEvent';

const clickButtonPoint = (type, btnName, locationKey) => {
  // v1和v2的点击按钮打点方法不同,绿色支付页不打点(2025-07-01绿色也加上了)
  if (type === 'V0') {
    clickButtonV0({
      btnName: btnName,
      locationKey: locationKey
    });
  }
  if (type === 'V1') {
    clickButtonV1({
      btnName: btnName,
      locationKey: locationKey
    });
  }
  if (type === 'V2') {
    clickButtonV2({
      btnName: btnName,
      locationKey: locationKey
    });
  }
  if (type === 'V3') {
    clickButtonV3({
      btnName: btnName,
      locationKey: locationKey
    });
  }
  if (type === 'V35') {
    clickButtonV35({
      btnName: btnName,
      locationKey: locationKey
    });
  }
};
// 地区 对 币种 的映射表:一对多
const areaCurrencyMap = {
  US: 'USD',
  JP: 'JPY',
  KR: 'KRW',
  TW: 'TWD',
  VN: 'VND',
  TH: 'THB',
  MY: 'MYR',
  SG: 'SGD',
  ID: 'IDR',
  PH: 'PHP',
  HK: 'HKD',
  MO: 'USD',
  RU: 'RUB',
  DE: 'EUR',
  GB: 'GBP',
  AU: 'AUD',
  FR: 'EUR',
  FI: 'EUR',
  DK: 'EUR',
  NL: 'EUR',
  CA: 'CAD',
  SE: 'EUR',
  PL: 'PLN',
  IT: 'EUR',
  CH: 'EUR',
  BE: 'EUR',
  SA: 'SAR',
  AE: 'AED',
  EG: 'USD',
  KW: 'USD',
  QA: 'QAR',
  OM: 'USD',
  BH: 'USD',
  GLOBAL: 'USD'
};
// 通过地区 获得 币种：一对多
const getCurrencyByArea = areaCode => {
  return areaCurrencyMap[areaCode] ? areaCurrencyMap[areaCode] : '';
};

// 美国大洲数据
const US_STATES = [
  {
    value: 'AL',
    label: 'Alabama'
  },
  {
    value: 'AK',
    label: 'Alaska'
  },
  {
    value: 'AZ',
    label: 'Arizona'
  },
  {
    value: 'AR',
    label: 'Arkansas'
  },
  {
    value: 'CA',
    label: 'California'
  },
  {
    value: 'CO',
    label: 'Colorado'
  },
  {
    value: 'CT',
    label: 'Connecticut'
  },
  {
    value: 'DE',
    label: 'Delaware'
  },
  {
    value: 'FL',
    label: 'Florida'
  },
  {
    value: 'GA',
    label: 'Georgia'
  },
  {
    value: 'HI',
    label: 'Hawaii'
  },
  {
    value: 'ID',
    label: 'Idaho'
  },
  {
    value: 'IL',
    label: 'Illinois'
  },
  {
    value: 'IN',
    label: 'Indiana'
  },
  {
    value: 'IA',
    label: 'Iowa'
  },
  {
    value: 'KS',
    label: 'Kansas'
  },
  {
    value: 'KY',
    label: 'Kentucky'
  },
  {
    value: 'LA',
    label: 'Louisiana'
  },
  {
    value: 'ME',
    label: 'Maine'
  },
  {
    value: 'MD',
    label: 'Maryland'
  },
  {
    value: 'MA',
    label: 'Massachusetts'
  },
  {
    value: 'MI',
    label: 'Michigan'
  },
  {
    value: 'MN',
    label: 'Minnesota'
  },
  {
    value: 'MS',
    label: 'Mississippi'
  },
  {
    value: 'MO',
    label: 'Missouri'
  },
  {
    value: 'MT',
    label: 'Montana'
  },
  {
    value: 'NE',
    label: 'Nebraska'
  },
  {
    value: 'NV',
    label: 'Nevada'
  },
  {
    value: 'NH',
    label: 'New Hampshire'
  },
  {
    value: 'NJ',
    label: 'New Jersey'
  },
  {
    value: 'NM',
    label: 'New Mexico'
  },
  {
    value: 'NY',
    label: 'New York'
  },
  {
    value: 'NC',
    label: 'North Carolina'
  },
  {
    value: 'ND',
    label: 'North Dakota'
  },
  {
    value: 'OH',
    label: 'Ohio'
  },
  {
    value: 'OK',
    label: 'Oklahoma'
  },
  {
    value: 'OR',
    label: 'Oregon'
  },
  {
    value: 'PA',
    label: 'Pennsylvania'
  },
  {
    value: 'RI',
    label: 'Rhode Island'
  },
  {
    value: 'SC',
    label: 'South Carolina'
  },
  {
    value: 'SD',
    label: 'South Dakota'
  },
  {
    value: 'TN',
    label: 'Tennessee'
  },
  {
    value: 'TX',
    label: 'Texas'
  },
  {
    value: 'UT',
    label: 'Utah'
  },
  {
    value: 'VT',
    label: 'Vermont'
  },
  {
    value: 'VA',
    label: 'Virginia'
  },
  {
    value: 'WA',
    label: 'Washington'
  },
  {
    value: 'WV',
    label: 'West Virginia'
  },
  {
    value: 'WI',
    label: 'Wisconsin'
  },
  {
    value: 'WY',
    label: 'Wyoming'
  },
  {
    value: 'DC',
    label: 'District of Columbia'
  },
  {
    value: 'AS',
    label: 'American Samoa'
  },
  {
    value: 'GU',
    label: 'Guam'
  },
  {
    value: 'MP',
    label: 'Northern Mariana Islands'
  },
  {
    value: 'PR',
    label: 'Puerto Rico'
  },
  {
    value: 'MH',
    label: 'Marshall Islands'
  },
  {
    value: 'FM',
    label: 'Federated States of Micronesia'
  },
  {
    value: 'PW',
    label: 'Palau'
  },
  {
    value: 'UM',
    label: 'Minor Outlying Islands'
  },
  {
    value: 'VI',
    label: 'Virgin Islands'
  },
  {
    value: 'AA',
    label: 'Armed Forces Americas'
  },
  {
    value: 'AE',
    label: 'Armed Forces Europe'
  },
  {
    value: 'AP',
    label: 'Armed Forces Pacific'
  }
];

export default {
  data() {
    let curLocationsVal = getCurLocation();
    let curLocationName = getLocationNameByVal(curLocationsVal);
    let locations = getLocaLclStor();
    return {
      curLocationName: curLocationName,
      curLocationVal: curLocationsVal,
      nextLocationName: '', // 切换后的区域名
      nextLocationVal: curLocationsVal, // 切换后区域值
      nextCurrency: '', // 切换后的币种
      // nextZipCode: '', // 切换后的邮编
      showAreaSelector: false,
      locations: locations,
      showAreaSwitchPopup: false, // 地区切换弹窗
      locationCurrencyList: [], // 地区币种列表
      zipCodeValidor: true, //zipcode校验
      pointsEventType: '', //打点类型 - 绕了好多弹窗，设置在这里

      nextStateName: '',
      nextStateCode: '',
      currentZipCodeList: [],
      zipCodeListCache: {}
    };
  },

  computed: {
    isJp() {
      const iso_two_code =
        localStorage.getItem('locationDetectByIP') &&
        JSON.parse(localStorage.getItem('locationDetectByIP')); // 根据 IP 获取地区码
      const area = iso_two_code && iso_two_code['ISO_TWO_CODE'];
      return area === 'JP' || globalConfig.getLanguages() === 'ja-JP';
    },
    privacyLink() {
      return `//gpassport.${globalConfig.getMainHost()}/center/${
        this.isJp ? 'Jp' : ''
      }ServicePrivacy/privacy`;
    },
    showCurZipCode() {
      return this.curLocationVal === 'US';
    },
    showNextZipCode() {
      return this.nextLocationVal === 'US';
    }
  },
  methods: {
    // 确认切换地区
    confirmSwitchArea(game_id, pointType = '') {
      if (
        this.nextLocationVal === this.curLocationVal &&
        this.nextCurrency === this.defaultCurrency &&
        this.nextZipCode === this.zipCode
      ) {
        this.hidePopup();
        return;
      }
      const params = {
        game_id,
        location_code: this.nextLocationVal,
        location_name: this.nextLocationName,
        zip_code: this.nextZipCode,
        default_currency: this.nextCurrency,
        force: this.havePayWay ? 0 : 1
      };
      this.$emit('confirmSwitchArea', params);
      clickButtonPoint(pointType, 'update_regions', locationType.areaLimit);
      if (pointType === 'V0') {
        window.sdkstoreDataLayer.push({
          eventName: 'bind_zipcode',
          eventType: this.pointsEventType,
          eventValue: this.nextZipCode
        });
      }
      if (pointType === 'V1') {
        window.webstorev1DataLayer.push({
          eventName: 'bind_zipcode',
          eventType: this.pointsEventType,
          eventValue: this.nextZipCode
        });
      }
      if (pointType === 'V2') {
        window.webstorev2DataLayer.push({
          eventName: 'bind_zipcode',
          eventType: this.pointsEventType,
          eventValue: this.nextZipCode
        });
      }
      if (pointType === 'V3') {
        window.webstorev3DataLayer.push({
          eventName: 'bind_zipcode',
          eventType: this.pointsEventType,
          eventValue: this.nextZipCode
        });
      }
      if (pointType === 'V35') {
        pushTrackEvent({
          eventName: 'bind_zipcode',
          eventType: this.pointsEventType,
          eventValue: this.nextZipCode
        });
      }
    },
    // 跳转查看政策(美国地区zipCode)
    jumpAreaLimitPolicy() {
      window.open(this.privacyLink, '_blank');
    },
    // 弹出地区选择弹窗
    showAreaSelect() {
      this.showAreaSelector = true;
    },
    // 弹出地区切换选择弹窗
    showAreaSwitch(pointType = '') {
      this.showAreaSwitchPopup = true;
      clickButtonPoint(pointType, 'go_changeregions', locationType.areaLimit);
    },
    // 提交地区切换信息(地区选择弹窗)
    async submitAreaSwithInfo(pointType = '') {
      await this.zipCodeValidorFunc();
      if (!this.zipCodeValidor) return;
      clickButtonPoint(pointType, 'select_regions', locationType.areaLimit);
      this.$emit('getAreaSwithInfo', {
        nextLocationName: this.nextLocationName || this.curLocationName,
        nextLocationVal: this.nextLocationVal || this.nextLocationVal,
        nextZipCode: this.nextZipCode,
        nextCurrency: this.nextCurrency,
        pointsEventType: this.isEditZipCode ? 'input' : 'ip' //打点绕了两个弹窗
      });
    },
    // 获取地区切换信息
    getAreaSwithInfo(info) {
      this.showAreaSwitchPopup = false;
      this.nextLocationName = info.nextLocationName;
      this.nextLocationVal = info.nextLocationVal;
      this.nextZipCode = info.nextZipCode;
      this.nextCurrency = info.nextCurrency;
      this.pointsEventType = info.pointsEventType;
    },
    // 获取切换后地区的币种
    hideAreaSelector(area) {
      this.showAreaSelector = false;
      this.nowCurrency = getCurrencyByArea(area.value);
      this.nextLocationName = area.name;
      this.nextLocationVal = area.value;
      this.showAreaSwitchPopup = true;
    },
    hidePopup() {
      this.$emit('hidePopup');
    },
    cancelAreaSwitchPopup() {
      this.showAreaSwitchPopup = false;
    },
    getUsStateOptions() {
      return US_STATES;
    },
    goUpdateZipCode() {
      this.hidePopup();
      this.$emit('handleZipCodeConfirmPopup', true);
    }
  }
};
